"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeLogEnvironment = void 0;
var tslib_1 = require("tslib");
var environment_1 = require("../const/environment");
exports.IkeLogEnvironment = tslib_1.__assign(tslib_1.__assign({}, environment_1.IkeEnvironment), { LAMBDA: 'lambda', ECS: 'ecs', UNKNOWN: 'unknown' });
//# sourceMappingURL=logshipper.js.map